document.addEventListener('DOMContentLoaded', () => {
  const isMobile = window.matchMedia('(max-width: 1199px)').matches;
  document.querySelectorAll('.surewarm-experience').forEach((sectionEl) => {
    const sliderEl = sectionEl.querySelector('[data-se-slider]');
    const featureEls = Array.from(sectionEl.querySelectorAll('[data-se-feature]'));
    if (!sliderEl || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return;

    const $slider = window.jQuery(sliderEl);
    if ($slider.hasClass('slick-initialized')) return;

    const autoplay = sliderEl.getAttribute('data-autoplay') === 'true';
    const autoplaySpeed = Number(sliderEl.getAttribute('data-autoplay-speed')) || 5000;
    const switchPauseMs = Number(sliderEl.getAttribute('data-switch-pause'));
    const switchPause = Number.isFinite(switchPauseMs) ? Math.max(0, switchPauseMs) : 1000;
    const fade = sliderEl.getAttribute('data-fade') === 'true';
    let playTimer = null;
    let pauseTimer = null;
    let endedCleanups = [];
    let holdStarted = false;

    const isElementVisible = (el) => {
      if (!el) return false;
      return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
    };

    const clearAdvanceTimers = () => {
      if (playTimer) {
        clearTimeout(playTimer);
        playTimer = null;
      }
      if (pauseTimer) {
        clearTimeout(pauseTimer);
        pauseTimer = null;
      }
      endedCleanups.forEach((fn) => fn());
      endedCleanups = [];
      holdStarted = false;
    };

    const resetVideoToFirstFrame = (video) => {
      if (!video) return;

      const tryReset = () => {
        try {
          video.currentTime = 0;
        } catch (e) {}
      };

      if (video.readyState >= 1) {
        tryReset();
      } else {
        const onLoadedMetadata = () => {
          tryReset();
          video.removeEventListener('loadedmetadata', onLoadedMetadata);
        };
        video.addEventListener('loadedmetadata', onLoadedMetadata);
      }
    };

    const pauseAllVideos = () => {
      sliderEl.querySelectorAll('video').forEach((video) => {
        try {
          video.pause();
        } catch (e) {}

        resetVideoToFirstFrame(video);
      });
    };

    const pauseCurrentVideosKeepFrame = () => {
      // Pause every video (incl. slick clones) so the hold is frozen, not looping.
      sliderEl.querySelectorAll('video').forEach((video) => {
        try {
          video.loop = false;
          video.pause();
        } catch (e) {}
      });
    };

    const playVideosInSlide = (slick, slideIndex) => {
      if (!slick || !slick.$slides) return;

      pauseAllVideos();

      const slideEl =
        sliderEl.querySelector('.slick-slide.slick-current') || slick.$slides.get(slideIndex);
      if (!slideEl) return;

      slideEl.querySelectorAll('video').forEach((video) => {
        if (!isElementVisible(video)) return;

        video.muted = true;
        video.playsInline = true;
        // Disable loop so the hold period freezes instead of restarting.
        video.loop = false;

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      });
    };

    const beginSwitchPause = () => {
      if (!autoplay || holdStarted) return;

      holdStarted = true;
      if (playTimer) {
        clearTimeout(playTimer);
        playTimer = null;
      }
      endedCleanups.forEach((fn) => fn());
      endedCleanups = [];

      pauseCurrentVideosKeepFrame();
      const holdStartedAt = performance.now();
      pauseTimer = setTimeout(() => {
        if (new URLSearchParams(window.location.search).has('se_debug')) {
          console.log('[switch pause]', Math.round(performance.now() - holdStartedAt), 'ms(配置', switchPause, 'ms)');
        }
        $slider.slick('slickNext');
      }, switchPause);
    };

    const scheduleAutoAdvance = () => {
      if (!autoplay) return;

      clearAdvanceTimers();

      // Fallback for image slides / video that never ends: wait autoplay_speed then hold.
      playTimer = setTimeout(() => {
        beginSwitchPause();
      }, autoplaySpeed);

      // Prefer starting the hold as soon as the visible video ends.
      const slideEl = sliderEl.querySelector('.slick-slide.slick-current');
      if (!slideEl) return;

      slideEl.querySelectorAll('video').forEach((video) => {
        if (!isElementVisible(video)) return;

        if (video.ended) {
          beginSwitchPause();
          return;
        }

        const onEnded = () => {
          beginSwitchPause();
        };
        video.addEventListener('ended', onEnded);
        endedCleanups.push(() => video.removeEventListener('ended', onEnded));
      });
    };

    const setActive = (index) => {
      featureEls.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
      });
    };

    featureEls.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        clearAdvanceTimers();
        $slider.slick('slickGoTo', index);
      });
    });

    $slider.on('init', (event, slick) => {
      setActive(0);
      setTimeout(() => {
        playVideosInSlide(slick, slick && typeof slick.currentSlide === 'number' ? slick.currentSlide : 0);
        scheduleAutoAdvance();
      }, 0);
    });

    $slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
      clearAdvanceTimers();
      if (typeof nextSlide === 'number') setActive(nextSlide);
      pauseAllVideos();
    });

    $slider.on('afterChange', (event, slick, currentSlide) => {
      playVideosInSlide(slick, currentSlide);
      scheduleAutoAdvance();
    });

    $slider.on('touchend', function () {
      scheduleAutoAdvance();
    });

    // Manual autoplay timing (video duration + switch pause); disable slick autoplay.
    if (autoplay && !isMobile) {
      $slider.on('mouseenter', clearAdvanceTimers);
      $slider.on('mouseleave', scheduleAutoAdvance);
      $slider.on('focusin', clearAdvanceTimers);
      $slider.on('focusout', scheduleAutoAdvance);
    }

    $slider.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      fade: fade,
      autoplay: false,
      adaptiveHeight: true,
      accessibility: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      pauseOnDotsHover: false,
      swipe: true
    });
  });
});
